import Seo from "@/components/Seo";

const About = () => (
  <div data-testid="about-page">
    <Seo
      title="À propos de Fast Alu | Expertise aluminium et dépannage"
      description="Fast Alu accompagne les particuliers et professionnels en Île-de-France pour la menuiserie aluminium, la métallerie et les urgences 24h/24."
    />
    <section className="bg-brand-blue/5" data-testid="about-hero">
      <div className="max-w-6xl mx-auto px-6 py-16">
        <h1 className="font-heading text-4xl uppercase" data-testid="about-title">
          À propos de Fast Alu
        </h1>
        <p className="text-brand-ink/70 mt-4" data-testid="about-subtitle">
          Une équipe engagée pour sécuriser vos accès et valoriser vos espaces avec des solutions aluminium fiables.
        </p>
      </div>
    </section>
    <section className="max-w-6xl mx-auto px-6 py-16 grid md:grid-cols-2 gap-10">
      <div className="space-y-4" data-testid="about-story">
        <h2 className="font-heading text-3xl uppercase" data-testid="about-story-title">
          Notre mission
        </h2>
        <p className="text-brand-ink/70" data-testid="about-story-text">
          Fast Alu intervient sur l’ensemble du Val-de-Marne avec une priorité donnée à Maisons-Alfort. Nous
          combinons rapidité, expertise technique et accompagnement sur-mesure pour répondre aux urgences et aux
          projets d’aménagement.
        </p>
        <p className="text-brand-ink/70" data-testid="about-story-text-2">
          Notre priorité : sécuriser vos locaux, renforcer vos façades et moderniser vos automatismes avec un
          suivi clair à chaque étape.
        </p>
      </div>
      <div className="space-y-4" data-testid="about-values">
        <h2 className="font-heading text-3xl uppercase" data-testid="about-values-title">
          Nos engagements
        </h2>
        <ul className="space-y-3 text-brand-ink/70">
          {[
            "Réactivité 24h/24 pour les urgences",
            "Qualité des matériaux aluminium et métal",
            "Conseils personnalisés pour chaque chantier",
            "Interventions locales rapides",
          ].map((value) => (
            <li key={value} data-testid={`about-value-${value.toLowerCase().replace(/\s+/g, "-")}`}>
              • {value}
            </li>
          ))}
        </ul>
      </div>
    </section>
  </div>
);

export default About;
